export const hashCode = (str) => {
    let hash = 0;
    if (str.length === 0) return hash;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    return hash >>> 0;
};

export const stringToColor = (str) => {
    let hash = hashCode(str);
    hash = hash>>6;
    return "#" + ((hash & 0xFF0FFF) << 0).toString(16).padStart(6, '0');
};

export const downloadFile = (downloadUrl) => {
    const fileName = downloadUrl.split('/media/').slice(-1)[0];
    const anchor = document.createElement('a');
    anchor.href = downloadUrl;
    anchor.download = fileName;
    anchor.target = "_blank";
    anchor.click();
};

export const truncateStringWithShortcut = (str, maxLength) => {
    const suffix = ".....(Shortcut)";
    if (str.length <= maxLength) {
        return str;
    }
    const truncationLength = maxLength - suffix.length;
    if (truncationLength <= 0) {
        return suffix;
    }
    return str.slice(0, truncationLength) + suffix;
};

export const getRelativeTime = (timestamp) => {
    if (!timestamp) return '';
    const now = new Date();
    const date = new Date(timestamp);
    const diffMs = now - date;
    const diffSecs = Math.floor(diffMs / 1000);
    const diffMins = Math.floor(diffSecs / 60);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffMonths = Math.floor(diffDays / 30);
    const diffYears = Math.floor(diffDays / 365);

    if (diffSecs < 60) return `${diffSecs}s ago`;
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 30) return `${diffDays}d ago`;
    if (diffMonths < 12) return `${diffMonths}mo ago`;
    return `${diffYears}y ago`;
};

export const formatDateTime = (timestamp) => {
    if (!timestamp) return '';
    return new Date(timestamp).toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    });
};

// True in a browser on an Android phone/tablet (touch gestures are enabled there)
export const isAndroidDevice = () =>
    typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent || '');
